export default "assets/images/icons/instagram-178dba44.svg";